import { useEffect, useState } from "react";

import { UserIcon, PrevIcon } from "@/components/Icon";

import { BetaIcon } from "@/assets/images";

type AppProps = {
  title: string;
  company_name?: string;
  client_code?: number | null;
  goBack?: boolean;
  style?: any;
  goBackFunction?: () => void;
  subtitle?: string;
};

const CommonHeader = ({
  title,
  goBack,
  style,
  company_name,
  client_code,
  goBackFunction,
  subtitle,
}: AppProps) => {
  const [companyName, setCompanyName] = useState<string>("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (company_name) {
      setCompanyName(company_name);
    }
  }, [company_name]);
  return (
    <>
      <title>
        {title
          ? `${title} - FINAC by Akssai ProjExel`
          : `FINAC by Akssai ProjExel`}{" "}
      </title>

      <div
        style={style ? style : {}}
        className={`row ${windowWidth <= 430 ? "mt-2" : ""}`}
      >
        <div className="col-md-12">
          <h2>
            {true ? (
              <span
                className="pointer mr-2 back-button"
                onClick={() => {
                  if (goBackFunction) {
                    goBackFunction();
                    return;
                  }
                  window.history.back();
                }}
              >
                <PrevIcon />
              </span>
            ) : null}
            {title}
            {title === "GST" ||
            title === "View E-Invoice" ||
            title === "View E-Way Bill" ||
            title === "Add OCR" ||
            title === "FORM GSTR-3B" ? (
              <img
                src={BetaIcon}
                alt="beta icon"
                className="ml-3"
                style={{ cursor: "pointer", width: "35px" }}
              />
            ) : (
              ""
            )}
          </h2>
          {client_code && (
            <div className="ml-4">
              <UserIcon /> &nbsp;
              {companyName} {"(" + client_code + ")"}
            </div>
          )}
          {subtitle && (
            <>
              <div className="ml-4 mt-0">
                <div
                  className="ml-3"
                  style={{ color: "#7c8db0" }}
                >
                  {subtitle}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CommonHeader;
